<div class="container" loading-spin [isLoading]="isPageLoading" [loadingSize]="'big'">
    <dashboard-screen *ngIf="!showDashboardPage" [screenKey]="keyOfScreen" [actionSubject$]="actionSubject$">
    </dashboard-screen>
</div>